import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, DynamicFormModule } from '@serviceos-ng/core';
import { EditBookingModalComponent } from './edit-booking-modal.component';



@NgModule({
  declarations: [EditBookingModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    DynamicFormModule
  ],
  exports: [EditBookingModalComponent]
})
export class EditBookingModalModule { }
